<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import utilsService from '@/services/core/utils.service';
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import ButtonSpinner from '@/components/shared/ButtonSpinner';
    import { DxColumn } from 'devextreme-vue/data-grid';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import DataSource from 'devextreme/data/data_source';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            AdminGrid,
            DxColumn,
            DxSelectBox,
            ButtonSpinner
        },
        data() {
            return {
                companyId: 0,
                filter: '',
                isLoading: 0,
                result: [],
                companiesLoaded: true,
                companiesDs: {},
                selectedCompany: null
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            save() {
                const selectedBatteries = this.$refs['copyBatteryGrid'].getSelectedRowKeys();
                const sourceBatteryIds = selectedBatteries.map(b => b.id) || [];

                if (sourceBatteryIds.length == 0) {
                    utilsService.showToast('You must provide at least one source battery.', 'error');
                    return;
                }

                if (!(this.selectedCompany || {}).id) {
                    utilsService.showToast('Please, select the destination company', 'error');
                    return;
                }

                if (+this.selectedCompany.id === this.companyId) {
                    utilsService.showToast('Invalid destination company', 'error');
                    return;
                }

                const url = `companies/${this.companyId}/copy-batteries?destinationCompanyId=${this.selectedCompany.id}`;

                this.isLoading++;
                httpService
                    .post(url, sourceBatteryIds)
                    .then(() => {
                        utilsService.showToast('Batteries copied successfully');
                        this.modalData.onSuccess && this.modalData.onSuccess();
                        this.close();
                    })
                    .finally(() => this.isLoading--);
            },
            loadCompanies() {
                this.selectedCompany = null;

                this.companiesLoaded = false;

                const url = `companies`;

                httpService
                    .get(url)
                    .then(data => {
                        this.companiesDs = new DataSource({
                            key: 'id',
                            store: data,
                            paginate: true,
                            pageSize: 10
                        });
                    })
                    .finally(() => (this.companiesLoaded = true));
            },
            loadBatteries() {
                const url = `companies/${this.companyId}/batteries`;

                this.isLoading++;

                httpService
                    .get(url)
                    .then(data => {
                        this.result = data;
                    })
                    .finally(() => this.isLoading--);
            }
        },
        mounted() {
            this.companyId = this.modalData.item;
            this.loadCompanies();
            this.loadBatteries();
        }
    };
</script>

<template>
    <Modal sizeClass="modal-lg">
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Copy Batteries</h3>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Destination company</label>
                        <div class="col-sm">
                            <DxSelectBox
                                v-model="selectedCompany"
                                :data-source="companiesDs"
                                display-expr="name"
                                :search-enabled="true"
                                search-mode="contains"
                                search-expr="name"
                                :search-timeout="200"
                                drop-down-button-template="loadIcon"
                            >
                                <template #loadIcon="{}">
                                    <div>
                                        <span v-show="!companiesLoaded" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                    </div>
                                </template>
                            </DxSelectBox>
                        </div>
                    </div>
                    <div v-if="isLoading > 0">Loading...</div>
                    <AdminGrid
                        v-if="isLoading == 0"
                        :data-source="result"
                        :showActions="false"
                        :showFilters="false"
                        :showExport="false"
                        :showSelection="true"
                        :showToolbar="false"
                        ref="copyBatteryGrid"
                    >
                        <DxColumn data-field="id" />
                        <DxColumn data-field="name" />
                        <DxColumn data-field="type" />
                        <DxColumn data-field="state" />
                        <DxColumn data-field="identifier" />
                        <DxColumn data-field="status" />
                    </AdminGrid>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                    <ButtonSpinner :isLoading="isLoading" text="Copy" />
                </div>
            </div>
        </form>
    </Modal>
</template>
